import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'cmv-validar-pld-modal',
	templateUrl: './validar-pld-modal.component.html',
	styleUrls: ['./validar-pld-modal.component.scss'],
})
export class ValidarPldModalComponent {
	@Input() isModalOpen: boolean = false;
	@Output() closedModal: EventEmitter<void> = new EventEmitter();

	onDismissModal(): void {
		this.isModalOpen = false;
		this.closedModal.emit();
	}
}
